import { render, staticRenderFns } from "./SingleLayerCoupe.vue?vue&type=template&id=5b61f208&scoped=true"
import script from "./SingleLayerCoupe.vue?vue&type=script&lang=ts"
export * from "./SingleLayerCoupe.vue?vue&type=script&lang=ts"
import style1 from "./SingleLayerCoupe.vue?vue&type=style&index=1&id=5b61f208&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61f208",
  null
  
)

export default component.exports